import axios from './axyos';

export type NotificationDto = {
  id: string;
  type?: string;
  ownerName?: string;
  adTitle?: string;
  adsId?: string;
  validatedDate?: string;
  reservationDates?: string[];
  reportId?: string;
  reportMessage?: string;
  reporterName?: string;
  reporterEmail?: string;
  chatTargetUserId?: string;
  createdAt?: string;
  read?: boolean;
};

export type ListNotificationsResponse = {
  data?: NotificationDto[];
  count?: number;
  unreadCount?: number;
  status?: number;
};

export const listCurrentUserNotificationsApi = (limit = 120) =>
  axios.get<ListNotificationsResponse>('/notifications/currentUser', {
    params: { limit },
  });

export const markAllCurrentUserNotificationsReadApi = () =>
  axios.post('/notifications/currentUser/read-all');
